module.exports = __webpack_public_path__ + "static/media/workshop_journal_tick.2a17397a.svg";